const logout = () => {
    window.localStorage.removeItem("nEkOtReSuEdArT");
    window.localStorage.removeItem("sLiAtEdReSuEdArT");
    window.localStorage.removeItem("sSeCcArEsUeDaRt");
    if(window.localStorage.getItem("ClientTable")){
      window.localStorage.removeItem("ClientTable");
    }
    if(window.localStorage.getItem("SurveyReportTable")){
      window.localStorage.removeItem("SurveyReportTable")
    }
    if(window.localStorage.getItem("ContractsTable")){
      window.localStorage.removeItem("ContractsTable")
    }
    if(window.localStorage.getItem("EmailTable")){
      window.localStorage.removeItem("EmailTable")
    }
    if(window.localStorage.getItem("FireExtinguisherTable")){
      window.localStorage.removeItem("FireExtinguisherTable")
    }
    if(window.localStorage.getItem("FireSuppressionTable")){
      window.localStorage.removeItem("FireSuppressionTable")
    }
    if(window.localStorage.getItem("InScheduleTable")){
      window.localStorage.removeItem("InScheduleTable")
    }
    if(window.localStorage.getItem("Invoice-OutgoingTable")){
      window.localStorage.removeItem("Invoice-OutgoingTable")
    }
    if(window.localStorage.getItem("MainContractorsTable")){
      window.localStorage.removeItem("MainContractorsTable")
    }
    if(window.localStorage.getItem("SchedulesTable")){
      window.localStorage.removeItem("SchedulesTable")
    }
    if(window.localStorage.getItem("SuppliersTable")){
      window.localStorage.removeItem("SuppliersTable")
    }
    if(window.localStorage.getItem("TaskTable")){
      window.localStorage.removeItem("TaskTable")
    }
    if(window.localStorage.getItem("clientTicketTable")){
      window.localStorage.removeItem("clientTicketTable")
    }
    if(window.localStorage.getItem("consultantsTable")){
      window.localStorage.removeItem("consultantsTable")
    }
    if(window.localStorage.getItem("installerTable")){
      window.localStorage.removeItem("installerTable")
    }
    if(window.localStorage.getItem("supportTicketTable")){
      window.localStorage.removeItem("supportTicketTable")
    }
    
    window.location.replace("/auth/login");
  };
  
  export default logout;
  